"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.TYPE = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _ContentEntity2 = _interopRequireDefault(require("./ContentEntity"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var TYPE = 'event';
exports.TYPE = TYPE;

var EventSeries = /*#__PURE__*/function (_ContentEntity) {
  (0, _inherits2["default"])(EventSeries, _ContentEntity);

  var _super = _createSuper(EventSeries);

  function EventSeries(json) {
    var _this;

    (0, _classCallCheck2["default"])(this, EventSeries);
    _this = _super.call(this, json);
    console.log('eventseries', json);
    _this.confirmation_template = json.confirmation_template;
    _this.documents = json.documents;
    _this.eventDates = json.eventDates;
    _this.eventTags = json.event_tags;
    _this.info = json.info;
    _this.sendConfirmation = json.send_confirmation;
    _this.tags = json.tags;
    _this.theme = json.theme;
    _this.title = json.title;
    _this.type = json.type;
    _this.backgroundImage = json.backgroundImage;
    _this.completionTags = json.completionTags;
    return _this;
  }

  return EventSeries;
}(_ContentEntity2["default"]);

var _default = EventSeries;
exports["default"] = _default;